import { IssueAssociationService as OvermapIssueAssociationService } from "@overmap-ai/core"

import type { RootState } from "../../store"
import type { AppSDK } from "../sdk"

export class IssueAssociationService extends OvermapIssueAssociationService<RootState, AppSDK> {
	host = import.meta.env.REACT_APP_API_URL
}
